import * as React from "react";
import { translate } from "../../../locales/translate";

export interface MaxLengthMessageProps {
  id?: string;
  value?: string;
  maxLength: number;
  maxLengthReachedMessage?: string;
}

export const MaxLengthMessage = (props: MaxLengthMessageProps) => {
  return (
    <div id={`${props.id}_maxlength_message_wrapper`} aria-live="polite" aria-atomic="true">
      {props.value && props.value?.length >= props.maxLength && (
        <span id={`${props.id}_maxlength_message`} className="input__warning alert warning-text">
          {props.maxLengthReachedMessage ?? translate("MaxLengthMessage")}
        </span>
      )}
    </div>
  );
};
